import axios from '../utils/axiosInstance';

export const deleteEvaAgentAPI = async (id) => {
  const response = await axios.delete(`ReportConfiguration/${id}`);
  return response;
};
